// components/dialogs/OptionDialog.jsx

import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  Box,
  TextField,
} from "@mui/material";

import Api from "../../Api/Api";
import { toast } from "sonner";

export default function OptionDialog({
  optionDialog,
  setOptionDialog,
  selectedColumn,
  optionRows,
  setOptionRows,
  fetchData,
}) {
  return (
    <Dialog
      open={optionDialog}
      onClose={() => setOptionDialog(false)}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Edit Options - {selectedColumn}</DialogTitle>

      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          {optionRows.map((row, index) => (
            <Box
              key={row.id || index}
              sx={{
                display: "flex",
                gap: 2,
                alignItems: "center",
              }}
            >
              {/* LABEL */}
              <TextField
                label="Label"
                fullWidth
                value={row.label}
                onChange={(e) => {
                  const updated = [...optionRows];
                  updated[index].label = e.target.value;
                  setOptionRows(updated);
                }}
              />

              {/* COLOR PICKER */}
              <input
                type="color"
                value={row.color || "#1976d2"}
                onChange={(e) => {
                  const updated = [...optionRows];
                  updated[index].color = e.target.value;
                  setOptionRows(updated);
                }}
                style={{
                  width: 60,
                  height: 40,
                  border: "none",
                  background: "transparent",
                  cursor: "pointer",
                }}
              />

              {/* DELETE BUTTON */}
              <Button
                color="error"
                variant="outlined"
                onClick={async () => {
                  try {
                    // ✅ delete from database immediately
                    if (row.id) {
                      await Api.post("/dashboard/deleteOption", {
                        id: row.id,
                      });
                    }

                    // ✅ remove from UI instantly
                    setOptionRows((prev) => prev.filter((_, i) => i !== index));
                  } catch (err) {
                    console.error(err);
                    toast.error("Delete failed");
                  }
                }}
              >
                Delete
              </Button>
            </Box>
          ))}

          {/* ADD NEW OPTION */}
          <Button
            variant="outlined"
            onClick={() => {
              setOptionRows((prev) => [
                ...prev,
                {
                  label: "",
                  color: "#1976d2",
                },
              ]);
            }}
          >
            + Add Option
          </Button>
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={() => setOptionDialog(false)}>Cancel</Button>

        <Button
          variant="contained"
          onClick={async () => {
            try {
              await Api.post("/dashboard/save-column-options", {
                column_name: selectedColumn,
                options: optionRows,
              });

              setOptionDialog(false);

              fetchData();
            } catch (err) {
              console.error(err);
            }
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
